export function ImpactPage() {
  return (
    <section
      id="impact"
      className="relative min-h-screen scroll-mt-24 overflow-hidden bg-neutral-950 pb-16 pt-32 text-neutral-100 md:pb-20 md:pt-36"
    >
      <div className="pointer-events-none absolute -left-24 top-24 h-56 w-56 rounded-full bg-white/10 blur-3xl" />
      <div className="pointer-events-none absolute -right-20 top-32 h-64 w-64 rounded-full bg-white/10 blur-3xl" />

      <div className="relative mx-auto w-full max-w-7xl px-4 md:px-8">
        <div>
          <p className="text-xs uppercase tracking-[0.22em] text-white">
            Problem
          </p>
          <h1 className="mt-3 text-3xl font-semibold tracking-tight md:text-4xl">
            Core Bottleneck
          </h1>
          <p className="mt-4 max-w-3xl text-white">
            Safety and surveillance are big problems. Data is overflowing, but we do not have the
            tools we need to keep our country safe, our workplaces safe, or even our jobs safe.
          </p>

          <article className="mt-8 rounded-2xl border border-white/15 bg-black/40 p-6 md:p-8">
            <p className="text-xs uppercase tracking-[0.16em] text-white">
              Opportunity
            </p>
            <p className="mt-4 max-w-5xl text-lg leading-8 text-neutral-100 md:text-2xl md:leading-10">
              A safer country, workplace, and home. All protected by our state-of-the-art
              autonomous mobile vehicles and camera systems. Making the world safer one system at a
              time.
            </p>
          </article>
        </div>
      </div>
    </section>
  );
}
